import { motion } from "framer-motion";
import Icon from "@/components/site/Icon";
import { BENEFITS } from "@/data/content";

export default function Benefits() {
  return (
    <section id="vorteile" className="section-pad bg-secondary hero-noise" data-testid="section-vorteile">
      <div className="container-x">
        <div className="max-w-2xl">
          <span className="text-sm font-bold tracking-wide text-[color:var(--brand-green-alt)] uppercase">Ihre Vorteile</span>
          <h2 className="mt-2 font-display text-4xl sm:text-5xl text-[color:var(--brand-navy)]">Mehr Sicherheit. Mehr Selbstbestimmung.</h2>
          <p className="mt-3 text-base sm:text-lg text-muted-foreground">Der Hausnotruf gibt Ihnen und Ihren Angehörigen ein gutes Gefühl – Tag und Nacht.</p>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6">
          {BENEFITS.map((b, i) => (
            <motion.div
              key={b.title}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.4, delay: (i % 3) * 0.06 }}
              className="rounded-2xl border border-border bg-white p-6 card-shadow card-shadow-hover"
            >
              <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-[color:var(--brand-navy)]">
                <Icon name={b.icon} className="h-6 w-6 text-[color:var(--brand-green)]" />
              </span>
              <h3 className="mt-4 text-lg font-bold text-[color:var(--brand-navy)]">{b.title}</h3>
              <p className="mt-2 text-[15px] leading-relaxed text-muted-foreground">{b.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
